const getPreflightDuration = (preflightTimeoutRaw?: string | null, shortForm = false) => {
  if (preflightTimeoutRaw === undefined) {
    return undefined;
  }

  let preflightDuration = shortForm ? 'Test' : 'Unlimited';
  if (preflightTimeoutRaw && !Number.isNaN(parseInt(preflightTimeoutRaw, 10))) {
    const preflightTimeoutDays = parseInt(preflightTimeoutRaw, 10);
    if (preflightTimeoutDays >= 36500) {
      preflightDuration = shortForm ? 'Test' : 'Unlimited';
    } else if (preflightTimeoutDays === 90 && shortForm) {
      preflightDuration = '3mo';
    } else if (preflightTimeoutDays === 365 && shortForm) {
      preflightDuration = '1yr';
    } else {
      preflightDuration = shortForm ? `${preflightTimeoutDays}d` : `${preflightTimeoutDays} days`;
    }
  }
  return preflightDuration;
};

export default getPreflightDuration;
